import { observer } from 'mobx-react'
import React from 'react'

import { useCustomT } from '@flowwai-frontend/shared/common-components'
import {
   ClientSocialMediaLink,
   useClientWebAppMobileScreenConfig
} from '@flowwai-frontend/bps-officer-web/iam'
import { MOBILE_VIEW_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

import { imageURLs } from '../Constants/WebAppMobileScreenConstants'

import * as Styles from './styles'
import './styles.css'

const WebAppMobileScreen = (): React.ReactElement => {
   const webAppMobileScreenT = useCustomT('common:webAppMobileScreen')

   const webAppMobileScreenConfig = useClientWebAppMobileScreenConfig()

   const hasMobileAppDetails = !!webAppMobileScreenConfig.mobileAppConfig

   const hasSocialMediaDetails = !!webAppMobileScreenConfig?.socialMediaLinks
      ?.length

   const renderSocialMedia = (socialMediaConfig: ClientSocialMediaLink) => (
      <a
         href={socialMediaConfig.navigationUrl}
         target='_blank'
         key={socialMediaConfig.id}
      >
         {socialMediaConfig.renderIcon()}
      </a>
   )

   const renderSocialMediasContainer = (
      socialMediasDetailsList: Array<ClientSocialMediaLink>
   ): React.ReactElement => (
      <div className={Styles.socialMediasContainerStyles}>
         <p className={Styles.getFollowUsOnTextStyles}>
            {webAppMobileScreenT('followUsOn')}
         </p>
         <div className={Styles.socialMediaListContainerStyles}>
            {socialMediasDetailsList.map(socialMedia =>
               renderSocialMedia(socialMedia)
            )}
         </div>
      </div>
   )

   const renderAppStore = () => (
      <a
         href={webAppMobileScreenConfig.mobileAppConfig?.googleAppLink}
         target={'_blank'}
      >
         <img
            src={imageURLs.GOOGLE_PLAY_IMG_LINK}
            alt={webAppMobileScreenT('googlePlayStore')}
         />
      </a>
   )

   const renderDescription = (description: string): React.ReactElement => (
      <p className={Styles.getDescriptionStyles}>{description}</p>
   )

   const renderSectionSeparator = (): React.ReactElement => (
      <div className={Styles.sectionSeparatorContainerStyles}>
         <hr className={Styles.getHorizontalLineStyles} />

         <span className={Styles.getSectionSeparatorTextStyles}>
            {webAppMobileScreenT('or')}
         </span>

         <hr className={Styles.getHorizontalLineStyles} />
      </div>
   )

   const renderMobileAppDetailsWithSocialLinks = (): React.ReactElement => (
      <>
         {renderSectionSeparator()}
         {renderDescription(
            webAppMobileScreenConfig.mobileAppConfig
               ?.mobileAppDescriptionText ?? ''
         )}
         {renderAppStore()}
      </>
   )

   const renderDesktopView = (): React.ReactElement => (
      <img
         src={`${MOBILE_VIEW_BASE_URL_PREFIX}${webAppMobileScreenConfig.appPreviewImageUrl}`}
         alt={webAppMobileScreenT('webView')}
         className={Styles.desktopViewImageStyles}
      />
   )

   const renderLogo = (): React.ReactElement => (
      <div className={Styles.logoStyles}>
         <img
            src={webAppMobileScreenConfig.appLogo}
            alt={webAppMobileScreenT('appLogo')}
            width={192}
         />
      </div>
   )

   return (
      <div
         className={`${Styles.containerStyles} web-App-Mobile-Screen`}
         style={{
            backgroundImage: `url(${MOBILE_VIEW_BASE_URL_PREFIX}${webAppMobileScreenConfig.bgImageUrl})`
         }}
      >
         {renderLogo()}
         <div className={Styles.webAppMobileScreenStyles}>
            {renderDesktopView()}
            {renderDescription(webAppMobileScreenT('webAppViewDescription'))}
            {hasMobileAppDetails
               ? renderMobileAppDetailsWithSocialLinks()
               : null}
            {hasSocialMediaDetails
               ? renderSocialMediasContainer(
                    webAppMobileScreenConfig.socialMediaLinks ?? []
                 )
               : null}
         </div>
      </div>
   )
}

export default observer(WebAppMobileScreen)
